import { render, staticRenderFns } from "./CalendarAddLinkDialog.vue?vue&type=template&id=065cf080&"
import script from "./CalendarAddLinkDialog.vue?vue&type=script&lang=ts&"
export * from "./CalendarAddLinkDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports